import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBriefcaseRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.8 6v2h6.4V6c0-.22-.18-.4-.4-.4h-5.6c-.22 0-.4.18-.4.4m-2.4 2V6c0-1.545 1.254-2.8 2.8-2.8h5.6c1.544 0 2.8 1.255 2.8 2.8v2h4c1.764 0 3.2 1.435 3.2 3.2V24c0 1.765-1.436 3.2-3.2 3.2H6.4A3.203 3.203 0 0 1 3.2 24V11.2C3.2 9.435 4.633 8 6.4 8zM5.6 18.4V24c0 .44.36.8.8.8h19.2c.44 0 .8-.36.8-.8v-5.6h-7.2v.8c0 .885-.716 1.6-1.6 1.6h-3.2c-.886 0-1.6-.715-1.6-1.6v-.8zm7.2-2.4h13.6v-4.8c0-.44-.36-.8-.8-.8H6.4c-.44 0-.8.36-.8.8V16z" })
});
export default SvgBriefcaseRegularIcon;
